import { useRef, useCallback, useEffect } from 'react';
const MIN_SWIPE_DISTANCE = 50;
export function useSwipeGesture({ onSwipeLeft, onSwipeRight }) {
    const swipeRef = useRef(null);
    const touchStartXRef = useRef(undefined);
    const handleTouchStart = useCallback((event) => {
        touchStartXRef.current = event.touches[0].clientX;
    }, []);
    const handleTouchEnd = useCallback((event) => {
        if (touchStartXRef.current === undefined)
            return;
        const diff = event.changedTouches[0].clientX - touchStartXRef.current;
        if (Math.abs(diff) > MIN_SWIPE_DISTANCE) {
            if (diff < 0) {
                onSwipeLeft();
            }
            else {
                onSwipeRight();
            }
        }
        touchStartXRef.current = undefined;
    }, [onSwipeLeft, onSwipeRight]);
    useEffect(() => {
        const element = swipeRef.current;
        if (!element)
            return;
        element.addEventListener('touchstart', handleTouchStart);
        element.addEventListener('touchend', handleTouchEnd);
        return () => {
            element.removeEventListener('touchstart', handleTouchStart);
            element.removeEventListener('touchend', handleTouchEnd);
        };
    }, [handleTouchStart, handleTouchEnd]);
    return { swipeRef };
}
